import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IState } from "./types";

// --------------------------------------------

export const initialState: IState = {
  role: undefined,
};

const slice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setRole(state, action: PayloadAction<string>) {
      state.role = action.payload;
    },
    setLogin(state, action: PayloadAction<any>) {
      state.login = action.payload;
    },
    logout(state) {
      state.login = null;
      state.role = undefined;
    },
  },
});

export default slice.reducer;

export const commonSlice = slice.reducer;

export const { setRole, setLogin, logout } = slice.actions;
